import { memo, useEffect, useState } from 'react'
import { useFormState } from 'react-final-form'
import { makeStyles, createStyles } from '@material-ui/core'
import Notice from 'components/Notice'
import { trackInAmplitude } from 'utils/tracking/amplitude'
import { AmplitudeEvent } from 'utils/tracking/amplitude/amplitude.interface'

const useStyles = makeStyles((theme) =>
  createStyles({
    wrapper: {
      marginTop: theme.spacing(2)
    }
  })
)

interface Props {
  isSecondary?: boolean
}

const InfoBox = ({ isSecondary }: Props) => {
  const { wrapper } = useStyles()

  const [isEmailWithTOnlineDomain, setIsEmailWithTOnlineDomain] =
    useState(false)
  const [isBannerClosed, setIsBannerClosed] = useState(false)

  const { values } = useFormState()

  const email = isSecondary
    ? values.debtors?.secondary?.contact?.email
    : values.debtors?.primary?.contact?.email

  useEffect(() => {
    setIsEmailWithTOnlineDomain(
      email && (email as unknown as string).includes('t-online')
    )
  }, [email])

  useEffect(() => {
    if (isEmailWithTOnlineDomain && !isBannerClosed) {
      trackInAmplitude(AmplitudeEvent.OnTOnlineEmailHintShown)
    }
  }, [isEmailWithTOnlineDomain, isBannerClosed])

  const handleClose = () => {
    trackInAmplitude(AmplitudeEvent.OnTOnlineEmailHintClosed)
    setIsBannerClosed(true)
  }

  if (isEmailWithTOnlineDomain && !isBannerClosed) {
    return (
      <div className={wrapper}>
        <Notice type="warning" onClose={handleClose}>
          <strong>Geben Sie eine andere E-Mail-Adresse an.</strong>
          <br />
          <br />
          Aus technischen Gründen können wir derzeit keine Angebote an
          E-Mail-Adressen von T-Online senden. Die E-Mail-Adresse ist wichtig,
          weil Sie damit Ihr Passwort festlegen. Wenn Sie Ihre Angebote sehen
          wollen, benötigen Sie das Passwort, um sich einzuloggen.
        </Notice>
      </div>
    )
  }

  return null
}

export default memo(InfoBox)
